
// ===========================================
// AXIOS LIBRARY IMPORT AND CONFIG PLUGIN
// ===========================================

// Import Vue and Axios
import Vue from 'vue'

import Axios from 'axios'
import VueAxios from 'vue-axios'


// Prototype vue for getting Axios alias on http
Vue.prototype.$http = Axios


// Use Axios and VueAxios on vue
Vue.use(VueAxios, Axios)